import { render } from "./PushNotificationComponent.vue?vue&type=template&id=11f356d9"
import script from "./PushNotificationComponent.vue?vue&type=script&lang=js"
export * from "./PushNotificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pushNotification/PushNotificationComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11f356d9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11f356d9', __exports__)) {
    api.reload('11f356d9', __exports__)
  }
  
  module.hot.accept("./PushNotificationComponent.vue?vue&type=template&id=11f356d9", () => {
    api.rerender('11f356d9', render)
  })

}


export default __exports__